import { render, staticRenderFns } from "./editResume.vue?vue&type=template&id=074d52b4&scoped=true&"
import script from "./editResume.vue?vue&type=script&lang=js&"
export * from "./editResume.vue?vue&type=script&lang=js&"
import style0 from "./editResume.vue?vue&type=style&index=0&id=074d52b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074d52b4",
  null
  
)

export default component.exports